import { IConcernCategoryHook } from '@models';
import { ConcernService } from '@services';
import { useStore } from '@stores';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

export const useConcernCategories = (): IConcernCategoryHook => {
  const { concernStore } = useStore();
  const {
    concernCategories,
    skipCount,
    currentPage,
    totalCount,
    maxResultCount,
    loading,
    handlePageChange,
  } = concernStore;
  const [name, setName] = useState<string>('');
  const [sorting, setSorting] = useState<string | undefined>();

  useEffect(() => {
    concernStore.getAllCategories({
      name,
      maxResultCount,
      skipCount,
      sorting,
    });
  }, [concernStore, name, maxResultCount, skipCount, sorting]);

  const handleSortChange = (value?: string) => {
    setSorting(value);
    concernStore.setSkipCount(0);
    concernStore.setCurrentPage(1);
  };

  const handleNameSearch = debounce((text: string) => {
    setName(text);
    concernStore.setSkipCount(0);
    concernStore.setCurrentPage(1);
  }, 500);

  const fetchAllForExport = useCallback(async () => {
    const result = await ConcernService.getAllCategories({
      name,
      maxResultCount: totalCount || 10000,
      skipCount: 0,
      sorting,
    });
    return result.items;
  }, [name, totalCount, sorting]);

  return {
    loading,
    dataSource: Array.from(concernCategories.values()),
    totalCount,
    currentPage,
    handleNameSearch,
    handlePageChange,
    handleSortChange,
    sorting,
    fetchAllForExport,
  };
};
